module.exports = __webpack_public_path__ + "static/img/physicalTests.4f6526f8.svg";